import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
import {
  type BeFilterSummaryResponse,
  type Block,
  type Category,
  type CategoryPagedListQuery,
  type CheckCategoryNameRequest,
  type CheckCategoryUsage,
  type EntityOut,
  type FilterDetail,
  type FilterPagedListQuery,
  type FilterRequest,
  type PagedList,
} from 'Types/beFiltersApi'
import {
  type ChannelType,
  type SubscriptionType,
} from '../types/FilterCondition'

const endpoints = ((baseURL: string) => {
  return {
    searchFilters: (idList: number) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/filters`,
    deleteFilter: (idFilter: number) => `${baseURL}/api/filters/${idFilter}`,
    filters: `${baseURL}/api/filters`,
    filter: `${baseURL}/api/filter`,
    simulateByConf: (idList: number) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/simulate`,
    //  categories
    categories: `${baseURL}/api/categories`,
    checkCategoryUse: (idCategory: number) =>
      `${baseURL}/api/categories/${idCategory}/checkuse`,
    checkCategoryName: `${baseURL}/api/categories/checkname`,
    deleteCategory: (idCategory: number) =>
      `${baseURL}/api/categories/${idCategory}`,
    category: `${baseURL}/api/category`,
    //
    getEntitiesUsingFilter: (idFilter: number) =>
      `${baseURL}/api/filters/${idFilter}/entities`,
  }
})(process.env.BEFILTERS_URL as unknown as string)

export const beFiltersApiSearchFilters = async (
  query: FilterPagedListQuery,
  idList: number,
): Promise<PagedList<BeFilterSummaryResponse>> => {
  const url = endpoints.searchFilters(idList)
  return await apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(query),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data)
}

export const beFiltersApiGetFilter = async (
  idFilter: number,
): Promise<FilterDetail> => {
  const url = `${endpoints.filters}/${encodeURIComponent(idFilter)}`
  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}

export const beFiltersApiCreateFilter = async (
  filter: FilterRequest,
): Promise<FilterDetail> => {
  const url = endpoints.filter
  return await apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(filter),
  }).then((res) => res.data)
}

export const beFiltersApiEditFilter = async (
  filter: FilterRequest,
  id: number,
): Promise<FilterDetail> => {
  const url = `${endpoints.filters}/${encodeURIComponent(id)}`
  return await apiWrapper({
    method: 'put',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(filter),
  }).then((res) => res.data)
}

export const beFiltersApiGetPagedCategories = async (
  params: CategoryPagedListQuery,
): Promise<PagedList<Category>> => {
  const url = endpoints.categories
  const urlWithQuery = url + '?' + encodeParams(params)
  return await apiWrapper({
    method: 'get',
    url: urlWithQuery,
  }).then((res) => res.data)
}

export const beFiltersApiGetCategoryById = async (
  id: number,
): Promise<Category> => {
  const url = `${endpoints.categories}/${encodeURIComponent(id)}`
  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}

export const beFiltersApiCreateCategory = async (
  Name: string,
): Promise<Category> => {
  const url = endpoints.category
  return await apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ Name }),
  }).then((res) => res.data)
}

export const beFiltersApiEditCategory = async (
  category: Category,
): Promise<Category> => {
  const url = `${endpoints.categories}/${category.Id}`
  return await apiWrapper({
    method: 'put',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(category),
  }).then((res) => res.data)
}

export const beFiltersApiCheckCategoryName = async (
  req: CheckCategoryNameRequest,
): Promise<{ Exists: boolean }> => {
  const url = `${endpoints.checkCategoryName}`
  return await apiWrapper({
    method: 'put',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(req),
  }).then((res) => res.data)
}

export const beFiltersApiCheckCategoryUse = async (
  idCategory: number,
): Promise<CheckCategoryUsage[]> => {
  return await apiWrapper({
    method: 'get',
    url: endpoints.checkCategoryUse(idCategory),
  }).then((res) => res.data)
}

export const beFiltersApiDeleteCategory = async (
  idCategory: number,
): Promise<boolean> => {
  return await apiWrapper({
    method: 'delete',
    url: endpoints.deleteCategory(idCategory),
  }).then((res) => res.data)
}

export const beFiltersApiDeleteFilter = async (
  idFilter: number,
): Promise<boolean> => {
  return await apiWrapper({
    method: 'delete',
    url: endpoints.deleteFilter(idFilter),
  }).then((res) => res.data)
}

export const beFiltersApiSimulateByConf = async (
  idList: number,
  blocks: Block[],
  channel: ChannelType,
  status: SubscriptionType[],
): Promise<number> => {
  const url = endpoints.simulateByConf(idList)
  const urlWithQuery = url + '?' + encodeParams({ channel, status })
  return await apiWrapper({
    method: 'post',
    url: urlWithQuery,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(blocks),
  }).then((res) => res.data)
}

//

export const beFiltersApiGetEntitiesUsingFilter = async (
  idFilter: number,
): Promise<EntityOut[]> => {
  return await apiWrapper({
    method: 'get',
    url: endpoints.getEntitiesUsingFilter(idFilter),
  }).then((res) => res.data)
}
